import Validate from '../modules/Validate.js';
import Popup from '../modules/CommonPopup';
import { scrollToElement, loadLibrary } from '../modules/Util.js';
import { pharmaciesMap } from "../store/PharmaciesMap.js";
import { pharmaciesSearch } from "../store/PharmaciesSearch.js";
import createAjaxSpinner from '../modules/AjaxSpinner.js';
import { startTimer } from '../store/Countdown.js';
import {LIB_URL} from '../App';
const setMaskPromise = import('/_src/js/modules/Mask.js');

const ERROR_MESSAGE = 'Произошла ошибка. Попробуйте позднее';

import('../modules/Form.js').then(function ({default: Form}) {
    let $step1 = $('.js-order-step[data-step="basket"]');
    const isOrderPage = App.H.hasClass('page-store-ordering');

    if ($step1.find(`.js-order-check:not([disabled]`).length === $step1.find(`.js-order-check:checked`).length){
        $step1.find(`.js-order-check-all`).attr('checked', true);
    }

    if ($.cookie('step') && isOrderPage){
        let baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        history.pushState(null, null, baseUrl + '#' + $.cookie('step'));

        if ($.cookie('step') === 'order-delivery') {
            if (!$('.js-map-pharmacies').data('rendered')) {
                pharmaciesMap();
            }
            if (!$('.js-pharmacy-choice').data('rendered')) {
                pharmaciesSearch($('.js-pharmacy-choice')[0]);
            }
        }

        if ($.cookie('step') === 'order-confirmation' || $.cookie('step') === 'order-contacts') {
            let $btnStepElement = $('.js-order-step[data-step="confirmation"]') || $('.js-order-step[data-step="contacts"]');
            if ($('.js-mask-phone', $btnStepElement).length) {
                let prevPlaceholderArr = [];
                let itiArr = [];

                loadLibrary([
                    LIB_URL.JQ_INTLTELINPUT,
                    LIB_URL.JQ_INPUTMASK
                ], () => {
                    $('.js-mask-phone', $btnStepElement).each(function(i) {
                        let $input = $(this);
                        let value = $input.val();

                        $input.attr('data-intl-tel-input-id', i);
                        $input.intlTelInput({
                            onlyCountries: ['ru','kz','md','am','az','ge','uz','kg','tj','mn','by'],
                            initialCountry: $input.data('country-mask') ? $input.data('country-mask') : 'ru',
                            nationalMode: false,
                            utilsScript: '/js/libs/intlTelInput/utils.js'
                        });

                        let iti = window.intlTelInputGlobals.getInstance(this);
                        let prevPlaceholder = $input.attr('placeholder');

                        prevPlaceholderArr.push(prevPlaceholder);

                        iti.promise.then(function() {
                            setMaskPromise.then(({setMask}) => {
                                setMask($input);
                            });
                            iti.setNumber(value);
                            $input.val(value);
                        });

                        itiArr.push(iti);

                        $input[0].addEventListener("countrychange", function() {
                            setMaskPromise.then(({setMask}) => {
                                setMask($input);
                            });
                        });

                        $input[0].addEventListener("open:countrydropdown", function() {
                            $('html').addClass('_countrydropdown');
                        });

                        $input[0].addEventListener("close:countrydropdown", function() {
                            $('html').removeClass('_countrydropdown');
                        });
                    });
                });
            }
        }
    }

    App.D.on('click', '.js-tab-title, .js-open-tab-link', function() {
        const $clickedTab = $(this);
        const clickedTabName = $clickedTab.attr('href') ? $clickedTab.attr('href').substring(1) : '';
        if ($clickedTab.closest('.ordering-tabs').length && isOrderPage) {
            document.cookie = "step=" + clickedTabName;
        }
        if (clickedTabName === 'order-delivery') {
            if (!$('.js-map-pharmacies').data('rendered')) {
                pharmaciesMap();
            }
            if (!$('.js-pharmacy-choice').data('rendered')) {
                pharmaciesSearch($('.js-pharmacy-choice')[0]);
            }
        }
    });

    // Смс уже зарегистрированному пользователю - получить код
    App.D.on('keydown', '.js-order-form .js-sms-phone-field', function(e) {
        if (e.keyCode == 13) {
            e.preventDefault();

            $(this).closest('.js-order-login-form').find('.button.js-order-sms-get').trigger('click');
        }
    });

    App.D.on('click', '.js-order-sms-get', function(e) {
        e.preventDefault();

        const btn = $(this);
        let $btnForm = btn.parents('.js-order-login-form');
        let $btnErrorMsg = btn.siblings('.js-error-message');
        let $phoneInput = $btnForm.find('.js-sms-phone-field');
        let $phoneLabel = $phoneInput.closest('.js-input-wrap').find('[data-label]');
        let $phoneCode = $btnForm.find('.js-sms-code');
        let codeMinLength = $phoneCode.data('code-minlength');
        let $codeCheck = $btnForm.find('.js-order-sms-check');
        let $phoneReset = $btnForm.find('.js-order-phone-reset');
        let $recaptcha = $btnForm.find('.js-recaptcha');

        new Validate().validateField($phoneInput);

        /* Если каптча не пройдена, то показываем ошибку */
        if ($recaptcha.hasClass('_notvalidated')) {
            $recaptcha.addClass('_error');
        }

        if (!$phoneInput.hasClass('_error') && !$phoneInput.hasClass('_notvalidated') && !$recaptcha.hasClass('_error') && $phoneInput.val().length > 0) {
            ajaxSpinner.show();
            btn.addClass('_disabled');
            $.ajax({
                method: "GET",
                url: btn.data('sms'),
                dataType: "json",
                data: {
                    'input': $phoneInput.val()
                },
                success: (response) => {
                    if (response.success) {
                        $phoneInput.removeClass('_notvalidated');
                        $btnForm.removeClass('_code-disabled');
                        btn.not('.js-order-sms-repeat').addClass('hidden');
                        $codeCheck.removeClass('hidden _hidden');
                        $phoneReset.removeClass('hidden');
                        $phoneCode.prop('disabled', false).attr('data-required', '');
                        $phoneCode.attr('data-minlength', codeMinLength);
                        $('.js-sms-wrap').removeClass('hidden');

                        if ($btnForm.find('.js-countdown')) {
                            let countdownTime = $('.js-countdown').data('countdown');
                            $('.js-countdown').html(countdownTime);
                            startTimer();
                        }

                        if (btn.hasClass('js-order-sms-repeat')) {
                            $('.js-code-not').removeClass('_hidden');
                            $('.js-code-repeat').addClass('_hidden');
                        }

                        if (!response.isUser) {
                            const $userRegisterForm = $btnForm.find('.js-order-user-register');
                            $userRegisterForm.removeClass('hidden');
                            $userRegisterForm.find('input').each((ind, item) => {
                                $(item).prop('disabled', false).attr('data-required', '');
                            })
                        }

                        if ($btnForm.find('.js-auth-submit')) {
                            $btnForm.find('.js-auth-submit').removeClass('_hidden');
                        }

                        $(this).closest('.js-order-form')
                            .find('.mobile-menu-sum--order .js-order-next')
                            .removeClass('_sms-get')
                            .addClass('_sms-check');
                    } else {
                        console.log(response.message || ERROR_MESSAGE);
                        $btnErrorMsg.html(response.message || ERROR_MESSAGE);
                    }
                },
                error: () => {
                    console.log('Ошибка получения данных');
                },
                complete: () => {
                    ajaxSpinner.hide();
                    btn.removeClass('_disabled');
                }
            });
        } else {
            if (!$phoneInput.hasClass('_mask-valid')) {
                $phoneInput.addClass('_error').removeClass('_filled')
                    .parent().addClass('_error');
                $phoneLabel.text($phoneLabel.text().length > 0 ? $phoneLabel.text() : window.validateMessages.required);
            }
        }
    });

    App.D.on('click', '.js-order-phone-reset', function(e) {
        e.preventDefault();
        let $btnForm = $(this).closest('.js-order-login-form');
        $btnForm.find('input:not(.js-sms-phone-field)').each((id, el) => {
            $(el).val('').removeClass('_error').closest('.js-input-wrap').removeClass('_filled');
        });
        $btnForm.find('.js-order-sms-check, .js-order-phone-reset, .js-sms-wrap, .js-order-user-register').addClass('hidden');
        $btnForm.find('.js-order-sms-get').removeClass('hidden');
        $btnForm.find('.js-mask-phone').val('');
        $('.js-order-submit').attr('disabled', true);
    })

    // Смс уже зарегистрированному пользователю - проверить код
    App.D.on('keydown', '.js-order-form .js-sms-code', function(e) {
        if (e.keyCode == 13) {
            e.preventDefault();

            $(this).closest('.js-order-login-form').find('.js-order-sms-check').trigger('click');
        }
    });

    App.D.on('click', '.js-order-sms-check', function(e) {
        e.preventDefault();

        const btn = $(this);
        const $btnForm = btn.parents('.js-order-login-form');
        let $btnErrorMsg = btn.siblings('.js-error-message');
        let $phoneInput = $btnForm.find('.js-sms-phone-field');
        let $phoneLabel = $phoneInput.closest('.js-input-wrap').find('[data-label]');
        let $phoneCode = $btnForm.find('.js-sms-code');
        const $codeLabel = $phoneCode.closest('.js-input-wrap').find('[data-label]');
        const phoneCodeMinLength = $phoneCode.data('code-minlength') || 1;
        const isAuthForm = $btnForm.hasClass('store-auth-form');
        const isRegForm = $btnForm.hasClass('store-reg-form');
        const isOrderForm = $btnForm.closest('.js-order-form').length > 0; //!isRegForm && !isAuthForm;

        const validator = new Validate();
        validator.validateField($phoneInput);
        validator.validateField($phoneCode);

        let dataObj = {
            'input': $phoneInput.val(),
            'code': $phoneCode.val(),
        };

        if ($('.js-order-user-register').length && !$('.js-order-user-register').hasClass('hidden')) {
            $('.js-order-user-register').find('input').each((ind, item) => {
                validator.validateField($(item));
                dataObj[$(item).attr('name')] = $(item).val();
            })
        }

        if (!$phoneInput.hasClass('_error') && !$phoneInput.hasClass('_notvalidated') && !$phoneCode.hasClass('_error')
             && $phoneCode.val().length >= phoneCodeMinLength && $phoneInput.val().length > 0
             && $('.js-order-user-register').find('input._error').length === 0) {
            ajaxSpinner.show();
            btn.addClass('_disabled');

            $.ajax({
                method: "GET",
                url: btn.data('sms'),
                dataType: "json",
                data: dataObj,
                success: (response) => {
                    if (response.success) {
                        if (response.redirect) {
                            window.location.href = response.redirect;
                            return;
                        }

                        if ($btnForm.find('.js-countdown')) {
                            $('.js-countdown').html('00:00');
                        }

                        $btnForm.addClass('_success');
                        $phoneCode.prop('disabled', true).removeAttr('data-required');
                        $phoneCode.removeAttr('data-minlength');

                        if (isOrderForm) {
                            $('.js-order-user-name').addClass('_filled').prop('disabled', false);
                            $('.js-order-user-email').addClass('_filled').prop('disabled', false);
                            $('.js-order-user-name .js-input').val(response.name);
                            $('.js-order-user-email .js-input').val(response.email);
                            btn.closest('.js-order-form').find('.mobile-menu-sum--order .js-order-next').removeClass('_disabled');
                            $btnForm.addClass('hidden');
                            $('.js-order-phone-reset').addClass('hidden');
                            $('.order-account__info-phone').html($('.js-sms-phone-field').val());
                            $('.js-order-account').removeClass('hidden');
                            $('.js-order-submit').removeAttr('disabled');
                            $(this).closest('.js-order-form')
                                .find('.mobile-menu-sum--order .js-order-next')
                                .removeClass('_sms-check');
                        }

                        if (isRegForm) {
                            $btnForm.find('.js-reg-submit').removeClass('_hidden');
                        }
                    } else {
                        console.log(response.message || ERROR_MESSAGE);
                        $btnErrorMsg.html(response.message || ERROR_MESSAGE).removeClass('hidden');
                    }
                },
                error: () => {
                    console.log('Ошибка получения данных');
                },
                complete: () => {
                    ajaxSpinner.hide();
                    btn.removeClass('_disabled');
                }
            });
        } else {
            if ($phoneInput.hasClass('_error') || $phoneInput.hasClass('_notvalidated') || $phoneInput.val().length === 0) {
                $phoneInput.addClass('_error').removeClass('_filled')
                    .parent().addClass('_error');
                $phoneLabel.text($phoneLabel.text().length > 0 ? $phoneLabel.text() : window.validateMessages.required);
            }
            if ($phoneCode.val().length < phoneCodeMinLength) {
                $phoneCode.addClass('_error').removeClass('_filled');
                $codeLabel.text($codeLabel.text().length > 0 ? $codeLabel.text() : window.validateMessages.required);
            }
        }
    });

    // Выбор аптеки из списка
    App.D.on('change', ('.js-pharm-radio'), function(e) {
        let pharmRadio = $(this);
        let pharmId = pharmRadio.val();
        let $pharmRadioAddress = pharmRadio.siblings('.js-pharmacy-info').find('.js-pharm-radio-address');

        $('#js-pharmacy-address').val(pharmId);
        $(this).closest('.js-order-form').find('.js-order-next').removeAttr('disabled');

        if ($pharmRadioAddress) {
            $('#js-pharmacy-address-text').val($pharmRadioAddress.text());
        }

        if ($('.js-pharm-radio:checked').length > 0) {
            $('.js-order-step').find('.mobile-menu-sum .js-order-next').removeClass('_disabled');
        }

        resetTabsState();
    });

    // Закрытие открытых дубликатов попапов при переключении табов
    App.D.on('click', '.js-tab-title', function() {
        $('.js-order-form .js-common-popup').each(function() {
           $(this)
               .hide()
               .find('.js-common-popup-close')
               .click();
           $(this).show();
        });
    });


    // блокируем взаимодействие во время ajax запросов
    let ajaxSpinner = {show: ()=>{}, hide: ()=>{}};
    $('.js-order-form').eq(0).closest('.js-tab-contents').each(function (i, wrapperDom) {
        ajaxSpinner = createAjaxSpinner(wrapperDom);

        $(wrapperDom).on('pharmaciesSearch:before', '.js-pharmacy-choice', ajaxSpinner.show);
        $(wrapperDom).on('pharmaciesSearch:complete', '.js-pharmacy-choice', ajaxSpinner.hide);
        App.D.on('loadMore:before', '.js-more-container', ajaxSpinner.show);
        App.D.on('loadMore:complete', '.js-more-container', ajaxSpinner.hide);
    });

    // Изменение веса/объема лекарства
    App.D.on('change', '.js-product-type', function(e) {
        let btn = $(this);
        let productId = btn.parents('.js-product-item').data('product');
        let actionUrl = btn.parents('.js-order-form').data('url');
        let action = btn.data('action');
        let btnSelect = btn.val();
        let deliveryChecked = $step1.find('.js-delivery-choice').find('input:checked').attr('id');

        ajaxSpinner.show();

        $.ajax({
            method: "GET",
            url: actionUrl,
            dataType: "json",
            data: {
                'productId': productId,
                'typeSelect': btnSelect,
                'action': action
            },
            success: (response) => {
                if (response.success) {
                    $step1.html(response.basket);
                    $step1.find('.js-delivery-choice #' + deliveryChecked).attr('checked', true);

                    // Делаем кнпоку "далее" доступной, т.к. пункт выдачи сейчас только самовывоз и он выбран
                    $step1.find('.js-order-next').removeClass('_disabled');
                    setCheckedProducts();

                    let currHeight = $('.js-tab-contents > .js-tab-content').filter('._active').outerHeight();
                    $('.js-tabs').find('> .js-tab-contents').css({
                        'min-height': `${currHeight}px`
                    });

                    $('.js-common-popup').each(function() {
                        new Popup(this);
                        if ($(this).hasClass('common-popup--opened')) {
                            $(this).trigger('popup:close');
                        }
                    });

                } else {
                    console.log(response.message || ERROR_MESSAGE);
                }
            },
            error: (err) => {
                console.log('Ошибка получения данных: ' + err);
            },
            complete: () => {
                ajaxSpinner.hide();
            }
        });
    });

    $('.js-product-action').each(function() { // TODO: перенести в success обновления формы т.к. этот код выполнится только один раз
        if ($(this).data('action') == 'plus') {
            let $productQuantity = $(this).siblings('.js-product-quantity');

            if ($productQuantity.val() >= $productQuantity.data('max')) {
                $(this).addClass('_disabled');
            }
        }
    });


    // Изменение количества, добавить в избранное, удалить, проверка промокода App.W.on('scroll', throttle(throttleScroll, 100));
    let plusTimeout;

    App.D.on('click', '.js-product-action', function(e) {
        e.preventDefault();

        let $btn = $(this);
        let productId = $btn.parents('.js-product-item').data('product');
        let $productQuantity = $btn.siblings('.js-product-quantity');
        let actionUrl = $btn.parents('.js-order-form').data('url');
        let btnAction = $btn.data('action'); // действия: plus, minus (для количества), remove, favourite, promocode
        let actionValue;
        let deliveryChecked = $step1.find('.js-delivery-choice').find('input:checked').attr('id');
        let $currentStep = $btn.closest('.js-order-step');
        let curStep = $btn.closest('.js-order-step').data('step') ? $btn.closest('.js-order-step').data('step') : '';

        if (btnAction === 'favourite' && $btn.hasClass('_active')) {
            btnAction = 'notFavorite';
        }

        if (btnAction == 'promocode') {
            $btn.closest('.js-promocode').find('.order-info__promocode-bottom').remove();
            actionValue = $btn.parents('.js-promocode').addClass('_loading').find('.js-promocode-input').val();
        }

        if (btnAction == 'promocode-cancel') {
            $btn.closest('.js-promocode').find('.order-info__promocode-bottom').remove();
            $btn.parents('.js-promocode').removeClass('_success _error').find('.js-promocode-input').val('');
            actionValue = $btn.parents('.js-promocode').addClass('_loading').find('.js-promocode-input').val();
        }

        if ($btn.hasClass('_disabled')) {
            return false;
        }

        let nextStepBtnDisabled = $btn.closest('.js-order-form').find('.js-delivery-choice .js-order-next').hasClass('_disabled');

        if (btnAction == 'plus') {
            let val = Number($productQuantity.val());

            if (!$productQuantity.data('max') || val + 1 <= $productQuantity.data('max')) {
                $productQuantity.val(val + 1);
                clearTimeout(plusTimeout);
                plusTimeout = setTimeout(getData, 500);
            } else {
                return false;
            }
        } else if (btnAction == 'minus') {
            let val = Number($productQuantity.val());

            if (val - 1 >= 1) {
                $productQuantity.val(val - 1);
                clearTimeout(plusTimeout);
                plusTimeout = setTimeout(getData, 500);
            } else {
                return false;
            }
        } else {
            getData();
        }

        function getData() {
            ajaxSpinner.show();

            $.ajax({
                method: "GET",
                url: actionUrl,
                dataType: "json",
                data: {
                    'productId': productId,
                    'action': btnAction,
                    'value': actionValue,
                    'step': curStep,
                    ...(['plus','minus'].includes(btnAction) ? {count: $productQuantity.val()} : {})
                },
                success: (response) => {
                    if (response.success) {
                        if (btnAction == 'promocode' || btnAction == 'promocode-cancel') {
                            $btn.parents('.js-promocode')
                                .removeClass('_loading')
                                .find('.js-input-wrap').removeClass('_error');
                        }
                        $('.js-common-popup', $step1).each(function() {
                            App.D.trigger('popup:destroy', {dom: this});
                        });

                        if (btnAction == 'favourite') {
                            App.D.find('.js-header-favorite').addClass('_in-favorite');
                        }

                        $currentStep.html(response[curStep]);

                        if ($currentStep.find('.js-delivery-choice')) {
                            $currentStep.find('.js-delivery-choice #' + deliveryChecked).attr('checked', true);
                        }

                        setCheckedProducts();

                        let currHeight = $('.js-tab-contents > .js-tab-content').filter('._active').outerHeight();
                        $('.js-tabs').find('> .js-tab-contents').css({
                            'min-height': `${currHeight}px`
                        });

                        if (nextStepBtnDisabled) {
                            $currentStep.find('.js-order-next').addClass('_disabled');
                        } else {
                            $currentStep.find('.js-order-next').removeClass('_disabled');
                        }

                        if ($currentStep.find('.js-promocode-input').length > 0 && $currentStep.find('.js-promocode-input').val().length === 0) {
                            $currentStep.find('.js-promocode-input').closest('.js-input-wrap').removeClass('_focused');
                        } else {
                            $currentStep.find('.js-promocode-input').closest('.js-input-wrap').addClass('_focused');
                        }

                        $('.js-common-popup').each(function () {
                            new Popup(this);
                            if ($(this).hasClass('common-popup--opened')) {
                                $(this).trigger('popup:close');
                            }
                        });

                        resetTabsState();

                        if (!$('.js-map-pharmacies').data('rendered')) {
                            pharmaciesMap();
                        }
                        if (!$('.js-pharmacy-choice').data('rendered')) {
                            pharmaciesSearch($('.js-pharmacy-choice')[0]);
                        }

                        $('.js-common-popup', $step1).each(function() {
                            new Popup(this);
                        });
                    } else {
                        console.log('Error', response.message);

                        if (btnAction == 'promocode' || btnAction == 'promocode-cancel') {
                            $currentStep.find('.js-promocode').removeClass('_loading _success').addClass('_error');
                            $currentStep.find('.js-promocode').find('.js-input-wrap').after(`
                                <div class='order-info__promocode-bottom'>
                                    <span class='error-msg'>${response.message || ERROR_MESSAGE}</span>
                                    <span class='promocode-cancel js-product-action' data-action='promocode-cancel'>Отменить</span>
                                </div>
                            `);
                        }
                    }
                },
                error: (err) => {
                    console.log('Ошибка получения данных: ' + err);
                },
                complete: () => {
                    ajaxSpinner.hide();
                }
            });
        }
    });

    App.D.on('input', '.js-promocode-input', function() {
        $(this).removeClass('_error').parents('.js-promocode').removeClass('_success _error _loading');

        if ($(this).val().length === 0) {
            $(this).closest('.js-input-wrap').removeClass('_focused');
        } else {
            $(this).closest('.js-input-wrap').addClass('_focused');
        }

        // обновляем остальные копии поля промо-кода
        $('.js-promocode-input').not(this).val(this.value).blur();
    });

    App.D.on('change', '.js-delivery-choice input[type="radio"]', function() {
        if ($('.js-delivery-choice').find('input:checked')) {
            $('.js-delivery-choice').parents('.js-order-form').find('.js-order-next').removeClass('_disabled');
        }
    });

    $('.js-order-form').each((i, formDom) => {
        if (!formDom.formInit) formDom.formInit = new Form(formDom);
    });

    // Отправка данных и переход на следующий шаг
    App.D.on('click', '.js-order-next', function(e) {
        e.preventDefault();

        if ($(this).hasClass('_sms-get')) {
            $('.js-order-login-form._active .button.js-order-sms-get').trigger('click');
            return false;
        }
        if ($(this).hasClass('_sms-check')) {
            $('.js-order-login-form._active .button.js-order-sms-check').trigger('click');
            return false;
        }
        if ($(this).hasClass('_pharm-select')) {
            $('.js-map').find('.js-pharmacy-select').length > 0 && $('.js-map').find('.js-pharmacy-select').trigger('click');
            return false;
        }

        let btn = $(this);
        let btnStep = btn.data('next-step');
        let $btnStepElement = $('.js-order-step[data-step="' + btnStep + '"]');
        let btnHref = btn.data('href');
        let $btnErrorMsg = btn.siblings('.js-error-message');
        let $form = btn.parents('.js-order-form');
        let form = $form[0];
        let stepUrl = $form.data('url');

        if (!$form[0].formInit) $form[0].formInit = new Form(form);
        if (!$form[0].stepValidate) $form[0].stepValidate = new Validate($form);

        // let formInit = new Form(form);
        // let stepValidate = new Validate($form);

        let deliveryValue = $form.find('input[name=delivery]:checked').val() || 'pharmacy';
        let deliveryBlock = '';
        if (deliveryValue == 'self' || deliveryValue == 'pharmacy') {
            deliveryBlock = 'pharmacy';
        } else if (deliveryValue == 'courier') {
            deliveryBlock = 'courier';
        }

        if (btnStep == 'delivery') {
            $form.find('.js-order-check:not(:checked)').each(function() {
                $(this).closest('.js-product-item').find('input:not([type=checkbox]), select').prop('disabled', true);
                $(this).closest('.js-product-item').find('.js-product-action[data-action="plus"], .js-product-action[data-action="minus"]')
                    .addClass('_disabled');
            });
        }

        if (!$form[0].stepValidate.validateAllFields()) {
            console.log('Order form has error');
            scrollToElement($('._error').first());
            return false;
        } else if ($('.js-product-item').hasClass('_not-available') || $('.js-product-item').hasClass('_type-not-available')) {
            App.D.trigger('popup:open', {
                name: btn.data('error-popup')
            });
            return false;
        } else {
            ajaxSpinner.show();
            btn.addClass('_disabled');

            $.ajax({
                method: "GET",
                url: stepUrl,
                dataType: "json",
                data: $form.find('input:not("#pharmacySearch"), textarea, select').serialize() + '&nextStep=' + btnStep,
                success: (response) => {
                    if (response.success) {
                        $('.js-common-popup', $btnStepElement).each(function() {
                            App.D.trigger('popup:destroy', {dom: this});
                        });

                        if (isOrderPage) {
                            document.cookie = "step=" + btnStep;
                            let baseUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
                            history.pushState(null, null, baseUrl + '#order-' + btnStep);
                        }

                        if (btnStep == 'delivery') {
                            $btnStepElement.html(response[btnStep][deliveryBlock]);
                            if (deliveryValue == 'self' || deliveryValue == 'pharmacy') {//console.log('deliveryValue',deliveryValue);
                                pharmaciesMap();
                                pharmaciesSearch($('.js-pharmacy-choice', $btnStepElement)[0]);
                            }
                            App.D.trigger('checkout', {
                                step: 2,
                                option: $('.js-delivery-choice input:checked + label').text()
                            });
                        } else {
                            $btnStepElement.html(response[btnStep]);

                            if ($('.js-mask-phone', $btnStepElement).length) {
                                let prevPlaceholderArr = [];
                                let itiArr = [];

                                loadLibrary([
                                    LIB_URL.JQ_INTLTELINPUT,
                                    LIB_URL.JQ_INPUTMASK
                                ], () => {
                                    $('.js-mask-phone', $btnStepElement).each(function(i) {
                                        let $input = $(this);
                                        let value = $input.val();

                                        $input.attr('data-intl-tel-input-id', i);
                                        $input.intlTelInput({
                                            onlyCountries: ['ru','kz','md','am','az','ge','uz','kg','tj','mn','by'],
                                            initialCountry: $input.data('country-mask') ? $input.data('country-mask') : 'ru',
                                            nationalMode: false,
                                            // utilsScript: '/js/libs/intlTelInput/utils.js'
                                        });
                                        window.intlTelInputGlobals.loadUtils('/js/libs/intlTelInput/utils.js');

                                        let iti = window.intlTelInputGlobals.getInstance(this);
                                        let prevPlaceholder = $input.attr('placeholder');

                                        prevPlaceholderArr.push(prevPlaceholder);

                                        iti.promise.then(function() {
                                            setMaskPromise.then(({setMask}) => {
                                                setMask($input);
                                            });
                                            iti.setNumber(value);
                                            $input.val(value);
                                        });

                                        itiArr.push(iti);

                                        $input[0].addEventListener("countrychange", function() {
                                            setMaskPromise.then(({setMask}) => {
                                                setMask($input);
                                            });
                                        });

                                        $input[0].addEventListener("open:countrydropdown", function() {
                                            $('html').addClass('_countrydropdown');
                                        });

                                        $input[0].addEventListener("close:countrydropdown", function() {
                                            $('html').removeClass('_countrydropdown');
                                        });
                                    });
                                });
                            }
                        }

                        if (btnStep == 'contacts') {
                            $('.js-order-step[data-step="' + btnStep + '"]')
                                .find('.mobile-menu-sum--order .js-order-next')
                                .removeClass('_disabled');

                            if (!$('.js-order-login-form._active').hasClass('_success')) {
                                $('.js-order-step[data-step="' + btnStep + '"]')
                                    .find('.mobile-menu-sum--order .js-order-next')
                                    .addClass('_sms-get');
                            }

                            App.D.trigger('checkout', {
                                step: 3,
                                option: $('.js-pharmacies-list input:checked + label .order-pharmacy__address .order-pharmacy__value').text()
                            });
                        }

                        if (btnStep == 'confirmation' && $('.header').find('.js-header-user').length > 0) {
                            $('.js-header-user').html(response.headerUser).removeClass('js-header-user');
                            $('.js-mobile-header-user').addClass('_hidden').next().removeClass('_hidden');
                            $('.js-mobile-menu-user').addClass('_hidden').next().removeClass('_hidden');

                            App.D.trigger('checkout', {
                                step: 4,
                                option: 'Ввод ПД'
                            });
                        }

                        if (isOrderPage) {
                            document.cookie = "step=" + btnHref;
                        }
                        $('.js-tab-title[id="' + btnHref + '"]').removeClass('_disabled').trigger('click');

                        $('.js-common-popup', $btnStepElement).each(function() {
                            new Popup(this);
                            if ($(this).hasClass('common-popup--opened')) {
                                $(this).trigger('popup:close');
                            }
                        });

                        scrollToElement($('.js-tabs'));
                        import('./SimpleTabs.js').then(function ({simpleTabsResetRequired}) {
                            simpleTabsResetRequired();
                        });

                        $form = $btnStepElement.find('.js-order-form');
                        form = $form[0];
                        $form[0].formInit = new Form(form);
                        $form[0].formInit.popLabels();
                    } else {
                        if (response.available === false) {
                            btnStep = 'basket';
                            btnHref = 'order-basket';

                            $('.js-common-popup', $btnStepElement).each(function() {
                                App.D.trigger('popup:destroy', {dom: this});
                            });

                            $btnStepElement.html(response[btnStep]);
                            $('.js-tab-title').addClass('_disabled');
                            $('.js-tab-title[id="' + btnHref + '"]').removeClass('_disabled').trigger('click');

                            scrollToElement($('.js-tabs'));
                            import('./SimpleTabs.js').then(function ({simpleTabsResetRequired}) {
                                simpleTabsResetRequired();
                            });

                            $('.js-common-popup', $btnStepElement).each(function() {
                                new Popup(this);
                            });

                            $form = $btnStepElement.find('.js-order-form');
                            form = $form[0];
                            $form[0].formInit = new Form(form);
                            $form[0].formInit.popLabels();
                        }

                        console.log(response.message || ERROR_MESSAGE);
                        $btnErrorMsg.html(response.message || ERROR_MESSAGE);
                    }
                },
                error: () => {
                    console.log('Ошибка получения данных');
                    $btnErrorMsg.html('Ошибка получения данных');
                },
                complete: () => {
                    ajaxSpinner.hide();
                    btn.removeClass('_disabled');
                }
            });
        }
    });


    // Отправка данных формы на последнем шаге
    App.D.on('click', '.js-order-submit', function(e) {
        e.preventDefault();

        let btn = $(this);
        let $form = btn.parents('.js-order-form');
        let formUrl = $form.data('url');
        const $btnErrorMsg = btn.siblings('.js-error-message');

        ajaxSpinner.show();

        $.ajax({
            method: "GET",
            url: formUrl,
            dataType: "json",
            data: $form.find('input, textarea, select').serialize(),
            success: (response) => {
                if (response.success) {
                    $('.js-order-thanks').html(response.submitSuccess);
                    scrollToElement($('.js-tabs'));
                    $form.parents('.ordering-tabs').addClass('order-success');

                    // App.D.trigger('popup:open', {name: 'pollOrder'});
                    $('.js-popup-order-id').val(response.orderId);
                    if (isOrderPage) {
                        document.cookie = "step= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
                    }

                    App.D.trigger('purchase', {
                        id: response.orderId,
                        affiliation: $('.js-pharmacies-list input:checked + label .order-pharmacy__address .order-pharmacy__value').text(),
                        revenue: response.orderPrice
                    });
                } else {
                    console.log(response.message || ERROR_MESSAGE);
                    $btnErrorMsg.html(response.message || ERROR_MESSAGE);
                }
            },
            error: () => {
                console.log('Ошибка получения данных');
                $btnErrorMsg.html('Ошибка получения данных');
            },
            complete: () => {
                ajaxSpinner.hide();
            }
        });
    });


    App.D.on('click', '.js-account-change', function(e) {
        ajaxSpinner.show();

        $.ajax({
            method: "GET",
            url: $(this).data('url'),
            dataType: "json",
            data: 'logout=true',
            success: (response) => {
                if (response.success) {
                    $('.js-order-account').addClass('hidden');
                    $('.js-order-login-form').removeClass('hidden');
                    $('.js-sms-wrap').addClass('hidden');
                    $('.js-order-sms-get').removeClass('hidden');
                    $('.js-order-sms-check').addClass('hidden');
                    $('.js-sms-phone-field').val('');
                    $('.js-sms-code').val('');
                    $('.js-order-user-register').addClass('hidden').find('input').each((ind, item) => {
                        $(item).val('').prop('disabled', true).removeAttr('data-required');
                    })
                    $('.js-order-submit').attr('disabled', true);
                } else {
                    console.log(response.message);
                    // $btnErrorMsg.html(response.message);
                }
            },
            error: () => {
                console.log('Ошибка получения данных');
            },
            complete: () => {
                ajaxSpinner.hide();
            }
        });

    });

    if (App.H.find('.js-order-check-all').length > 0 && $('.js-order-check-all').is(':checked')) {
        let $form = $('.js-order-check-all').closest('.js-order-form');
        $form.find('.js-order-check:not([disabled])').prop('checked', true);
        $form.find('.js-order-next').removeAttr('disabled');
        $form.find('.js-product-item').find('input:not([type=checkbox]), select').removeAttr('disabled');
    }

    App.D.on('change', '.js-order-check, .js-order-check-all', function(e) {
        e.preventDefault();

        let $btn = $(this);
        if ($btn.hasClass('_disabled') || $btn.is(':disabled')) {
            return false;
        }
        let productId = $btn.parents('.js-product-item').length ? $btn.parents('.js-product-item').data('product') : 'all';
        let actionUrl = $btn.parents('.js-order-form').data('url');
        let $currentStep = $btn.closest('.js-order-step');
        let curStep = $btn.closest('.js-order-step').data('step') ? $btn.closest('.js-order-step').data('step') : '';

        let nextStepBtnDisabled = $btn.closest('.js-order-form').find('.js-delivery-choice .js-order-next').hasClass('_disabled');

        ajaxSpinner.show();

        $.ajax({
            method: "GET",
            url: actionUrl,
            dataType: "json",
            data: {
                'productId': productId,
                'action': 'productCheck',
                'value': $btn.is(':checked'),
                'step': curStep,
            },
            success: (response) => {
                if (response.success) {
                    $currentStep.html(response[curStep]);

                    setCheckedProducts();

                    $('.js-common-popup', $currentStep).each(function() {
                        App.D.trigger('popup:destroy', {dom: this});
                    });

                    let currHeight = $('.js-tab-contents > .js-tab-content').filter('._active').outerHeight();
                    $('.js-tabs').find('> .js-tab-contents').css({
                        'min-height': `${currHeight}px`
                    });

                    if (nextStepBtnDisabled) {
                        $currentStep.find('.js-order-next').addClass('_disabled');
                    } else {
                        $currentStep.find('.js-order-next').removeClass('_disabled');
                    }

                    $('.js-common-popup', $currentStep).each(function() {
                        new Popup(this);
                        if ($(this).hasClass('common-popup--opened')) {
                            $(this).trigger('popup:close');
                        }
                    });

                    resetTabsState();
                } else {
                    console.log('Error', response.message);
                }
            },
            error: (err) => {
                console.log('Ошибка получения данных: ' + err);
            },
            complete: () => {
                ajaxSpinner.hide();
            }
        });
    });

    // function enableItemActions(item) {
    //     item.find('input:not([type=checkbox]), select').removeAttr('disabled');
    //     if (item.find('.js-product-quantity').val() !== 1 && item.find('.js-product-quantity').val() !== '1') {
    //         item.find('.js-product-action[data-action="minus"]').removeClass('_disabled');
    //     }
    //     if (item.find('.js-product-quantity').val() < item.find('.js-product-quantity').data('max') ||
    //         !item.find('.js-product-quantity').data('max')) {
    //         item.find('.js-product-action[data-action="plus"]').removeClass('_disabled');
    //     }
    // }

    // отмечаем выбранные продукты после аякс-запроса
    function setCheckedProducts() {
        const $productChecked = $step1.find('.js-order-check:checked');

        $productChecked.attr('checked', true);
        $step1.find(`.js-order-check-all`).attr('checked', $step1.find(`.js-order-check:not([disabled]`).length === $productChecked.length);

        if ($productChecked.length > 0) {
            $step1.find('.js-order-next').removeAttr('disabled');
        }
    }

    // дизейблим следующие табы, если были действия после перехода по ним назад
    function resetTabsState() {
        const curTabIndex = App.H.find('.js-tab-title._active').data('index');
        App.H.find(`.js-tab-title[data-index=${curTabIndex + 1}]`) && App.H.find(`.js-tab-title[data-index=${curTabIndex + 1}]`).addClass('_disabled');
        App.H.find(`.js-tab-title[data-index=${curTabIndex + 2}]`) && App.H.find(`.js-tab-title[data-index=${curTabIndex + 2}]`).addClass('_disabled');
    }
});
